export const enum AppRouteKey {
  LOGIN = '/login',
  CONFIRM_DELETE = '/confirm-delete',
  DELETE_SUCCESS = '/delete-success',
  VERIFIED_NUMBER = '/verified-number',
}
